import { MeditationRecordStatusType } from "api/meditationRecordApi";

// 완료 시점 저장값이 floor(AudioPlayerCell initialTime)·웹뷰 finished 시점의 state 지연으로
// duration보다 1~2초 작게 기록될 수 있어 보정. isEnded 조기 세팅 구간(종료 30초 전)과는 27초 여유.
export const REPLAY_COMPLETION_EPS_SECONDS = 3;

// "다시주기" 상태: 완료 이력(lastDoneAt)이 있으나 코치가 undone 처리해 재할당된 레코드
export const isRedoAssigned = (
  status: Pick<MeditationRecordStatusType, "isDone" | "lastDoneAt"> | undefined
): boolean => !!status && status.isDone === false && !!status.lastDoneAt;

// 재생 위치가 끝까지 도달했는지
export const isPlaybackAtEnd = (
  duration: number,
  currentTime: number
): boolean =>
  duration > 0 && currentTime >= duration - REPLAY_COMPLETION_EPS_SECONDS;
